import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ThemePatchService } from '@shared/services/theme-patch.service';
import { clearLocalStorageExceptLastLoginService } from './core/services/clearLocalStorageExceptLastLogin.service';
import { DomainService } from './core/services/domain-config.service';
import { SnackbarService } from './core/services/snackbar.service';
import { loadingStatus } from './core/states/shared/shared.selector';
import { getAgencyConfig } from './features/agency-config/states/agencyConfig.action';
import { agencyConfigSelector } from './features/agency-config/states/agencyConfig.selector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  _store = inject(Store);
  agencyConfig$ = this._store.select(agencyConfigSelector);
  loading$ = inject(Store).select(loadingStatus);
  clearLocalStorageExceptLastLoginService = inject(
    clearLocalStorageExceptLastLoginService
  );
  theme: string;
  configData: any;

  constructor(
    private translate: TranslateService,
    private snackBar: SnackbarService,
    private router: Router,
    private domainService: DomainService,
    private themePatchService: ThemePatchService
  ) {
    // initialize translate
    const lang = localStorage.getItem('lang');
    translate.setDefaultLang('vi');
    translate.use(lang || this.translate.getBrowserLang() || 'vi');
  }
  ngOnDestroy(): void {
    clearInterval(this.intervalID);
  }
  intervalID: any;
  ngOnInit() {
    this.getAgencyConfigInfo();
    let expires_at: any = null;
    if (localStorage.getItem('expires_at')) {
      expires_at = new Date(Number(localStorage.getItem('expires_at') || ''));
    }
    const now: any = new Date();

    if (expires_at && expires_at < now) {
      this.snackBar.warning('Hết phiên đăng nhập.Vui lòng đăng nhập lại');
      this.clearLocalStorageExceptLastLoginService.clearLocalStorageExceptLastLogin();

      this.router.navigate(['/login']);
    }
    this._store.dispatch(getAgencyConfig());
    this.theme = this.domainService.theme();
    this.themePatchService.setTheme(this.theme);
  }

  getAgencyConfigInfo() {
    this.agencyConfig$.subscribe((data) => {
      this.configData = data;
    });
  }
}
